import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Icons from "../../../../Config/Images";
import { UploadMediaRequestAPI } from "../../../../Store/Action/mediaAction";
import {
  getLoggedInUserDetailsAPI,
  logOutUserAPI,
  updateUserAPI,
} from "../../../../Store/Action/UserAction";
import { logout } from "../../../../Store/Slice/authSlice";
import Footer from "../../Layout/Footer/Footer";
import Header from "../../Layout/Header/Header";
import LogoutModal from "./CustomModals/LogoutModal";
import "./MyAccount.css";
import SettingComponent from "./Settings";
import { BASE_URL } from "../../../../Constants/AppConstants";

const MyAccount = () => {
  const accountCards = [
    { img: Icons.manage_profile_image, label: "Manage profile" },
    { img: Icons.my_order_image, label: "My Orders" },
    { img: Icons.my_address_img, label: "My Address" },
    { img: Icons.wallet_image, label: "Wallet" },
    { img: Icons.reward_point_image, label: "Reward Points" },
    { img: Icons.my_subscription_image, label: "My Subscription" },
    { img: Icons.share_image, label: "Share" },
    { img: Icons.tANDc_image, label: "Terms & Conditions" },
  ];

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loggedInUser, setLoggedInUser] = useState({});
  const [selectedFile, setSelectedFile] = useState(null);
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);

  // const user = useSelector((state) => state.auth.user);

  useEffect(() => {
    dispatch(
      getLoggedInUserDetailsAPI({}, (result) => {
        setLoggedInUser(result?.data?.[0]);
      })
    );
  }, [dispatch]);

  const handleToggleSettings = () => {
    setIsSettingsOpen((prev) => !prev); // Toggle settings
  };

  const handleFileChange = (e) => {
    const files = e.target.files;
    const file = files[0];
    const newImageSrc = URL.createObjectURL(file);
    if (file) {
      setSelectedFile(file);
      handleUpload(file); // Call upload function when file is selected
    }
  };
  const handleUpload = (file) => {
    // const driveName = "profile_photos";
    const driveName = "userProfile";
    const isMultiple = false;

    dispatch(
      UploadMediaRequestAPI([file], driveName, isMultiple, (result) => {
        const requestData = {
          user_profile_image_id: result?.data?.[0]?.file_storage_id,
        };
        if (result?.status) {
          dispatch(
            updateUserAPI(requestData, (result2) => {
              if (result2?.status) {
                // toast.success(result2?.message?.message);
                dispatch(
                  getLoggedInUserDetailsAPI({}, (result) => {
                    setLoggedInUser(result?.data?.[0]);
                  })
                );
              }
            })
          );
        } else {
          toast.error("Failed to upload profile photo.");
        }
      })
    );
  };

  const handleClick = (card) => {
    // Normalize the label for the navigation path
    const normalizedLabel = card.label.toLowerCase().replaceAll(" ", "-");

    if (card.label === "Log Out") {
      setIsModalOpen(true); // Open the modal
    } else if (card.label === "Terms & Conditions") {
      navigate(`/my-account/terms-and-conditions`); // Navigate to Terms & Conditions page
    } else {
      navigate(`/my-account/${normalizedLabel}`);
    }
  };
  const handleCloseModal = () => {
    setIsModalOpen(false); // Function to close the modal
  };

  const handleLogOut = () => {
    dispatch(
      logOutUserAPI({}, (result) => {
        if (result?.status) {
          dispatch(logout());
          toast.success(result?.data?.message);
          navigate("/login"); // Redirect to login page after logout
        }
        setIsModalOpen(false); // Close the modal after logout
      })
    );
  };

  return (
    <>
      <Header />
      <div className="my-account-container">
        <div className="account-header">
          <p className="ac-header-para">My Account</p>
          <div className="user-profile-div">
            <div className="profile-picture">
              {/* <img src={Icons.profile_picture_image} alt="Profile" /> */}
              <img
                className="user-image"
                src={
                  loggedInUser?.image
                    ? `${BASE_URL}${loggedInUser.image}`
                    : Icons.default_image
                }
                alt="Profile"
                onClick={() => document.getElementById("fileInput").click()} // Open file input on click
              />
              <input
                type="file"
                id="fileInput"
                style={{ display: "none" }}
                accept="image/*"
                onChange={handleFileChange}
              />
              <div className="camera-pic-image-div">
                <img
                  className="camera-pic"
                  src={Icons.camera_profile_image}
                  alt=""
                  onClick={() => document.getElementById("fileInput").click()} // Open file input on click
                />
              </div>
            </div>
            <div className="user-details">
              <p className="user-name-para">
                {/* {user?.user_details?.user_first_name} */}
                {loggedInUser?.user_first_name}
              </p>
              <p className="user-number-para">
                {loggedInUser?.user_mobile_number}
              </p>
            </div>

            <div className="setting-main-div" style={{ position: "relative" }}>
              <div
                className="top-left-side-div"
                style={{ cursor: "pointer" }}
                onClick={handleToggleSettings}
              >
                <img
                  src={Icons.accountSetting}
                  alt=""
                  className="setting-icon"
                />

                <img
                  style={{ cursor: "pointer", height: "6px", width: "12px" }}
                  src={
                    isSettingsOpen ? Icons.vectorUpIcon : Icons.vectorDownIcon
                  }
                  alt=""
                  className="down-arrow-icon"
                />
              </div>

              {isSettingsOpen && <SettingComponent />}
            </div>
          </div>
        </div>

        <div className="divider" />

        <div className="account-cards-grid">
          {accountCards.map((card, index) => (
            <div className="account-card" key={index}>
              <div className="card-content" onClick={() => handleClick(card)}>
                <img src={card.img} alt={card.label} />
                <p>{card.label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Modal Component */}
      {/* <div>{isSettingsOpen && <SettingComponent />}</div> */}
      <Footer />
    </>
  );
};

export default MyAccount;
